export default {
    dependencies: ['$element', 'xhrservice'],
    callable(ele, xhrservice) {
        let adId;
        let showButton;
        let hideButton;
        let actionButton;
        let box;
        let actionButtonOrigText;

        const select = function(key) {
            return ele.querySelector(`[data-${key}-mark-as-disposed]`);
        };

        const prevent = function(fn) {
            return function(e) {
                e.preventDefault();
                return fn(e);
            };
        };

        const show = function() {
            box.classList.remove('hidden');
        };

        const hide = function() {
            box.classList.add('hidden');
        };

        const wait = function(fn, time) {
            let complete;
            let timerDone;
            let args;
            let _this;

            setTimeout(() => {
                timerDone = true;
                resolve();
            }, time);

            function resolve() {
                if (args && timerDone && !complete) {
                    complete = true;
                    fn.apply(_this, args);
                }
            }

            return function() {
                /* eslint-disable */
                _this = this;
                args = Array.prototype.slice.call(arguments);
                /* eslint-enable */
                resolve();
            };
        };

        const dispose = function(e) {
            e.stopPropagation();
            actionButton.textContent = 'Markerer..';
            xhrservice
                .request({
                    url: '/user/markAsDisposed/xhr.json',
                    method: 'POST',
                    data: { finnkode: adId },
                    type: 'json',
                })
                .then(wait(handleSuccess, 500), wait(handleError, 500));
        };

        function handleSuccess() {
            const redirectToSelectRateePage = ele.hasAttribute(
                'data-has-possible-ratees'
            );
            if (redirectToSelectRateePage && adId) {
                window.location.replace(
                    `/review/selectratee.html?finnkode=${adId}`
                );
            } else {
                showButton.classList.add('hidden');
                hide();
            }
        }

        function handleError() {
            // we don't have a recovery strategy in this case, so just reset it.
            actionButton.textContent = actionButtonOrigText;
        }

        const init = function() {
            showButton = select('show');
            hideButton = select('hide');
            actionButton = select('set');
            box = select('confirmation');
            if (!showButton || !hideButton || !actionButton || !box) {
                return;
            }

            adId = actionButton.getAttribute('data-finnkode');

            actionButtonOrigText = actionButton.textContent;
            showButton.addEventListener('click', prevent(show));
            hideButton.addEventListener('click', prevent(hide));
            actionButton.addEventListener('click', prevent(dispose));
        };

        return init();
    },
};



// WEBPACK FOOTER //
// ./controllers/markAsDisposed.js